export const P_CLASS =
  "mb-[22px] font-body text-[19px] leading-[1.7] text-grindigo-800 [text-wrap:pretty]";

export const H2_CLASS =
  "mt-12 mb-5 first:mt-2 font-companion text-[28px] font-bold leading-[1.2] tracking-[-0.02em] text-primary";

export const PULL_QUOTE_CLASS =
  "my-10 rounded-r-2xl border-l-4 border-indigo-500 bg-[linear-gradient(135deg,#EEF2FF_0%,#F5F3FF_100%)] px-8 py-7 font-companion text-[22px] font-medium italic leading-[1.45] tracking-[-0.01em] text-grindigo-800";

export const ARTICLE_WRAPPER_CLASS = "px-[clamp(24px,5vw,80px)] pb-4";
export const ARTICLE_INNER_CLASS = "mx-auto max-w-[720px]";
